import { LoadingOutlined } from "@ant-design/icons";
import { Button, Form, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import { GetAvailablePositionsApi } from "../../../api/positions/GetAvailablePositionsApi";
import AddPositionUserApi from "../../../api/positions/AddPositionUserApi";

const { Option } = Select;

function AddUserPositionModal(props) {
  const [submit, setSubmit] = useState(false);
  const [positions, setPositions] = useState([]);

  function handleCancel() {
    setSubmit(false);
    setPositions([]);
    props.handleCancel();
  }

  useEffect(() => {
    if (props.visible) {
      getPositions();
    }
  }, [props.visible]);

  async function getPositions() {
    const apiResponse = await GetAvailablePositionsApi();
    if (apiResponse.success) {
      setPositions(apiResponse.data);
    }
  }

  async function onFinish(values) {
    setSubmit(true);
    const apiResponse = await AddPositionUserApi(
      values.position,
      props.user?.id
    );
    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add user try again later."
      );
    }
    handleCancel();
  }

  return (
    <Modal
      title="Add position"
      visible={props.visible}
      onOk={props.handleOk}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addPosition"
        onFinish={onFinish}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
      >
        <Form.Item
          label="Position"
          name="position"
          rules={[
            {
              required: true,
              message: "Please select a position!",
            },
          ]}
        >
          <Select
            showSearch
            placeholder="Select position"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            filterSort={(optionA, optionB) =>
              optionA.children
                .toLowerCase()
                .localeCompare(optionB.children.toLowerCase())
            }
          >
            {positions.map((position) => {
              return (
                <Option key={position.id} value={position.id}>
                  {position.designation + ", " + position.unit}
                </Option>
              );
            })}
          </Select>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-28"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddUserPositionModal;
